// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getAuth} from 'firebase/auth'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDfV4EB50sFz3d7SR9vzH3OugT2b9vTncQ",
  authDomain: "test-96a2f.firebaseapp.com",
  projectId: "test-96a2f",
  storageBucket: "test-96a2f.appspot.com",
  messagingSenderId: "92472732976",
  appId: "1:92472732976:web:4bd379b581fda491d5acf5",
  measurementId: "G-GDFQB53305"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth=getAuth()
export default app
